
export default {
  props: { curso: String },
  data() {
    return {
      items: [
        {
          icone: 'icone-informatica.png',
          titulo: 'Metodologia<br/>Prática',
          texto:
            'Prepare-se para conquistar o seu primeiro emprego com nossa metodologia. Através de uma abordagem prática e orientada por projetos, você desenvolverá as habilidades essenciais para se destacar no mercado de trabalho. Em casa, você terá acesso a aulas interativas online para adquirir conhecimentos teóricos e técnicos relevantes. Nos encontros presenciais, aplique o que aprendeu na plataforma em projetos reais e enfrente desafios do mundo profissional, para aprimorar suas habilidades técnicas, trabalho em equipe e resolução de problemas.',
        },
        {
          icone: 'icone-mentores.png',
          titulo: 'Preparação<br/>Profissional',
          texto:
            'Durante os encontros presenciais, você participará de debates e discussões sobre situações reais do mercado de trabalho, promovendo a troca de ideias e o compartilhamento de conhecimentos. Com nossa metodologia, você desenvolverá habilidades essenciais, como pensamento crítico, criatividade e colaboração. Ao enfrentar desafios reais, você estará preparado para lidar com situações similares no ambiente profissional, adquirindo uma base sólida de conhecimentos relevantes para o mercado de trabalho.',
        },
        {
          icone: 'icone-projetos.png',
          titulo: 'Encaminhamento<br/>para o Mercado',
          texto:
            'Nosso curso irá prepará-lo para identificar seu propósito, e apresentá-lo de forma efetiva para o mercado, com desenvolvimento de currículo, postura profissional e marketing pessoal. Além disso, a partir da parceria com a agência de empregos e estágios ABRE, você será encaminhado para oportunidades de trabalho que se encaixem com o seu perfil desenvolvido em nosso curso, e com seus interesses profissionais. Esteja preparado para trilhar seu caminho profissional com confiança e sucesso.',
        },
      ],
    }
  },
}
